import { Component, inject, Input } from '@angular/core';
import { TagStore } from '../../../stores/tag/tag.state';
import { ChipModule } from 'primeng/chip';
import { NgForOf } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { Tag } from '../../../models/tag';

@Component({
  selector: 'app-tag-list',
  standalone: true,
  imports: [ChipModule, NgForOf, TagModule],
  templateUrl: './tag-list.component.html',
  styleUrl: './tag-list.component.scss',
})
export class TagListComponent {
  readonly tagStore = inject(TagStore);

  @Input() tagIds: string[] = [];
  @Input() tags?: Tag[] = [];
  @Input() styleClass = '';
  @Input() severity:
    | 'success'
    | 'secondary'
    | 'info'
    | 'warning'
    | 'danger'
    | 'contrast'
    | undefined = undefined;
}
